// @ts-check
import { createColumnHelper } from "@tanstack/react-table"
import { buildClientSprintsTableCells } from "./ClientSprints.cells"
import { useClientSprintsTableFilters } from "./ClientSprints.filters"

export function buildClientSprintsTableColumns() {
  const { sprintTypeFilterTemplate } = useClientSprintsTableFilters()

  const {
    SprintCellTemplate,
    PeriodCellTemplate,
    TotalCompletedPointsCellTemplate,
    TotalCompletedPointsFooterTemplate,
    TotalDevHoursFooterTemplate,
    AverageHoursPerPointCellTemplate,
    AverageHoursPerPointFooterTemplate,
    FormattedNumberCellTemplate,
  } = buildClientSprintsTableCells()

  /** @type {import("./ClientSprints.controller.types").ClientSprintLogEntryColumnHelper} */
  const columnHelper = createColumnHelper()

  return [
    columnHelper.accessor("sprintNumberByClient", {
      header: "Sprint",
      cell: SprintCellTemplate,
      footer: "Totales",
      meta: {
        className: "sprint-number-column",
        filterElement: sprintTypeFilterTemplate,
      },
      filterFn: (row, _columnId, filterValue) => {
        const rowCloseType = row.original.closeType
        if (!filterValue) return true

        return rowCloseType === filterValue
      },
    }),

    columnHelper.display({
      id: "period",
      header: "Periodo",
      cell: PeriodCellTemplate,
      meta: {
        className: "period-column",
      },
    }),

    columnHelper.accessor("updatedBy", {
      header: "Responsable",
      meta: {
        className: "updated-by-column",
      },
      enableColumnFilter: false,
    }),

    columnHelper.accessor("totalCompletedPoints", {
      header: "Pts realizados",
      cell: TotalCompletedPointsCellTemplate,
      footer: TotalCompletedPointsFooterTemplate,
      meta: {
        className: "total-completed-points-column",
      },
      enableColumnFilter: false,
    }),

    columnHelper.accessor("totalDevHours", {
      header: "Horas totales dev",
      cell: FormattedNumberCellTemplate,
      footer: TotalDevHoursFooterTemplate,
      meta: {
        className: "total-dev-hours-column",
      },
      enableColumnFilter: false,
    }),

    columnHelper.display({
      id: "averageHoursPerPoint",
      header: "Hs/pt promedio",
      cell: AverageHoursPerPointCellTemplate,
      footer: AverageHoursPerPointFooterTemplate,
      meta: {
        className: "average-hours-per-point-column",
      },
    }),

    columnHelper.accessor("totalPlannedPoints", {
      header: "Pts por desarrollar",
      cell: FormattedNumberCellTemplate,
      footer: "-",
      meta: {
        className: "total-planned-points-column",
      },
      enableColumnFilter: false,
    }),

    columnHelper.accessor("totalEstimationPoints", {
      header: "Pts planificados",
      cell: FormattedNumberCellTemplate,
      footer: "-",
      meta: {
        className: "total-estimation-points-column",
      },
      enableColumnFilter: false,
    }),
  ]
}
